import { Component, OnInit, Input, OnChanges, SimpleChanges, Inject } from '@angular/core';
import { StepComponent } from '../stepcomponent.class';
import { IConfig } from '../../../../../lib/interfaces/config.interface';
import { NotificationsService } from '../../../../../lib/services/notifications.service';
import { INotification, NotificationType } from '../../../../../lib/interfaces/notification.interface';
import { ComponentGroup } from '../../../../../lib/enum/component-group.enum';
import { NextComponentService } from '../../../../../lib/services/next-component.service';
import { PersonalInfoComponent } from '../personal-info/personal-info.component';
import { ComponentName } from '../../../../enum/component-name.enum';
import { ResidenceInfoComponent } from '../residence-info/residence-info.component';
import { EmploymentInfoComponent } from '../employment-info/employment-info.component';
import { AdditionalInfoComponent } from '../additional-info/additional-info.component';
import { IComponentDetails } from '../../../../../lib/interfaces/component-details.interface';
import { StepType } from '../../../../../lib/enum/step-type.enum';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dt-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss'],
  standalone: false
})
export class StatusBarComponent implements OnInit, OnChanges {

  @Input() componants: StepComponent[];
  @Input() activeIndex: number;
  coBuyerActivated = false;
  isBuyNow = false;
  isLegacyCreditApp = false;
  componantList = [];
  constructor(@Inject('config') public config: IConfig,
              private notificationService: NotificationsService,
              private nextComponentService: NextComponentService) { }

  ngOnInit() {
    /* istanbul ignore else */
    if (this.config.Sitecore && this.config.Sitecore.CreditApplicationConfig && this.componants) {
      console.log(`status bar:  `);
      console.log(this.config.Sitecore);
      this.isBuyNow = this.config.Sitecore.isBuyNow;
      this.isLegacyCreditApp = this.config.Sitecore.isLegacyCreditApp;
      let Groups = this.config.Sitecore.CreditApplicationConfig.Groups;
      if(!this.config.Sitecore.isLegacyCreditApp){
        delete  Groups.PrequalLegacyCA;
      }
      Object.keys(Groups).forEach(key => {
        const cmp = this.componants.filter(x => x.groupName === key);
        this.componantList.push({
          groupName: key,
          title: Groups[key],
          isVisible: cmp[0] && cmp[0].isActive ? true : false,
          step: -1,
          totalStep: cmp.length,
          completed: false
        });
      });
      this.componantList[0].step = 0;
    }

    this.notificationService.notificationBroadcasted$.subscribe((n: INotification) => {
      if(n !== null) {
        if (n.Type === NotificationType.coBuyerActivation) {
          this.activateCoBuyerFlow();
        } else if (n.Type === NotificationType.coBuyerDeactivation || n.Type === NotificationType.startingNewCreditApp) {
          this.deActivateCoBuyerFlow();
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => {
      this.UpdateStatusBar(changes.activeIndex.currentValue, changes.activeIndex.previousValue || 0);
    });
  }

  activateCoBuyerFlow() {
    this.coBuyerActivated = true;
    this.componantList.forEach(cmp => {
      cmp.isVisible = true;
    });
  }

  deActivateCoBuyerFlow() {
    this.coBuyerActivated = false;
    
    this.componantList.forEach(cmp => {
      if (cmp.groupName === ComponentGroup.CoBuyerAdditional || cmp.groupName === ComponentGroup.CoBuyerEmployment
        || cmp.groupName === ComponentGroup.CoBuyerPersonal || cmp.groupName === ComponentGroup.CoBuyerResidence) {
        cmp.isVisible = false;
      }
    });
  }
  /* istanbul ignore next */
  showNext() {
    if (window && (window as any).buynow && (window as any).buynow.navigation) {
      (window as any).buynow.navigation.showNext();
    }
  }
  /* istanbul ignore next */
  hideNext() {
    if (window && (window as any).buynow && (window as any).buynow.navigation) {
      (window as any).buynow.navigation.hideNext();
    }
  }
  /* istanbul ignore next */
  showPrev() {
    if (window && (window as any).buynow && (window as any).buynow.navigation) {
      (window as any).buynow.navigation.showPrev();
    }
  }
  /* istanbul ignore next */
  hidePrev() {
    if (window && (window as any).buynow && (window as any).buynow.navigation) {
      (window as any).buynow.navigation.hidePrev();
    }
  }
   /* istanbul ignore next */
  UpdateStatusBar(index: number, lastIndex: number) {
    if (lastIndex !== 0 && index === 0 && this.isBuyNow && (window as any).buynow.navigation != null) {
      try {
        this.showNext();
        this.showPrev();
      } catch (e) {
        console.log(e);
      }
    } else if (index === 1 && this.isBuyNow && (window as any).buynow.navigation != null) {
      try {
        this.hideNext();
        this.hidePrev();
      } catch (e) {
        console.log(e);
      }
    }
    if (index !== 0 && this.isBuyNow) {
      this.hideNext();
    }

    if (index !== undefined && lastIndex !== undefined) {
      if (index - 1 === lastIndex) {
        this.nextStep(index);
      } else if (index + 1 === lastIndex) {
        this.backStep(index);
      } else {
        if (index > lastIndex) {
          this.forwardJump(index);
        } else {
          this.backwardJump(index);
        }
      }
    }
  }

  forwardJump(index) {
    const currentIndexComponant = this.componants[index];
    if (currentIndexComponant !== undefined) {
      const step = this.getIndex(currentIndexComponant.groupName, currentIndexComponant.componentName);
      const totalStep = this.componants.filter(x => x.groupName === currentIndexComponant.groupName).length;
      for (let j = 0; j < this.componantList.length; j++) {
        if (this.componantList[j].groupName === currentIndexComponant.groupName) {
          this.componantList[j].completed = step !== 0;
          this.componantList[j].step = step;
          this.componantList[j].totalStep = totalStep;
          if (this.componantList[j - 1]) {
            this.componantList[j - 1].completed = true;
            this.componantList[j - 1].step = this.componantList[j - 1].totalStep;
          }
          break;
        } else {
          this.componantList[j].completed = true;
          this.componantList[j].step = this.componantList[j].totalStep;
        }
      }
    }
  }

  backwardJump(index) {
    const currentIndexComponant = this.componants[index];
    const step = this.getIndex(currentIndexComponant.groupName, currentIndexComponant.componentName);
    const totalStep = this.componants.filter(x => x.groupName === currentIndexComponant.groupName).length;
    let flag = false;
    for (let j = 0; j < this.componantList.length; j++) {

      if (flag) {
        this.componantList[j].completed = false;
        this.componantList[j].step = -1;
      } else {
        if (this.componantList[j].groupName === currentIndexComponant.groupName) {
          this.componantList[j].completed = step !== 0;
          this.componantList[j].step = step;
          this.componantList[j].totalStep = totalStep;
          this.componantList[j + 1].completed = false;
          this.componantList[j + 1].step = 0;
          flag = true;
        } else {
          this.componantList[j].completed = true;
          this.componantList[j].step = this.componantList[j].totalStep;
        }
      }
    }
  }

  backStep(index) {
    const currentIndexComponant = this.componants[index];
    const step = this.getIndex(currentIndexComponant.groupName, currentIndexComponant.componentName);
    const totalStep = this.componants.filter(x => x.groupName === currentIndexComponant.groupName).length;
    let i = 0;
    this.componantList.forEach(cmp => {
      if (cmp.groupName === currentIndexComponant.groupName) {
        this.componantList[i].completed = step !== 0;
        this.componantList[i].step = step;
        this.componantList[i].totalStep = totalStep;
        this.componantList[i + 1].completed = false;
        this.componantList[i + 1].step = -1;
      }
      i++;
    });
  }


  nextStep(index) {
    const currentIndexComponant = this.componants[index];
    const step = this.getIndex(currentIndexComponant.groupName, currentIndexComponant.componentName);
    const totalStep = this.componants.filter(x => x.groupName === currentIndexComponant.groupName).length;
    let i = 0;
    this.componantList.forEach(cmp => {
      if (cmp.groupName === currentIndexComponant.groupName) {
        this.componantList[i].completed = step !== 0;
        this.componantList[i].step = step;
        this.componantList[i].totalStep = totalStep;
        this.componantList[i - 1].completed = true;
        this.componantList[i - 1].step = this.componantList[i - 1].totalStep;
      }
      i++;
    });
  }

  getIndex(gname: string, cname: string) {
    const componantArray = this.componants.filter(x => x.groupName === gname);
    return componantArray.findIndex(x => x.componentName === cname);
  }

  loadComponent(flag: boolean, groupName) {
    if (flag) {
      let nextComponent: IComponentDetails;
      switch (groupName) {
        case ComponentGroup.PersonalInfo: {
          nextComponent = {
            groupName: ComponentGroup.PersonalInfo,
            component: new StepComponent(PersonalInfoComponent,
              ComponentName.PersonalInfoComponent, ComponentGroup.PersonalInfo, true),
            componentName: ComponentName.PersonalInfoComponent,
          };
          break;
        }
        case ComponentGroup.ResidenceInfo: {
          nextComponent = {
            groupName: ComponentGroup.ResidenceInfo,
            component: new StepComponent(ResidenceInfoComponent,
              ComponentName.ResidenceInfoComponent, ComponentGroup.ResidenceInfo, true),
            componentName: ComponentName.ResidenceInfoComponent,
          };
          break;
        }
        case ComponentGroup.EmploymentInfo: {
          nextComponent = {
            groupName: ComponentGroup.EmploymentInfo,
            component: new StepComponent(EmploymentInfoComponent,
              ComponentName.EmploymentInfoComponent, ComponentGroup.EmploymentInfo, true),
            componentName: ComponentName.EmploymentInfoComponent,
          };
          break;
        }
        case ComponentGroup.AdditionalInfo: {
          nextComponent = {
            groupName: ComponentGroup.AdditionalInfo,
            component: new StepComponent(AdditionalInfoComponent,
              ComponentName.AdditionalInfoComponent, ComponentGroup.AdditionalInfo, true),
            componentName: ComponentName.AdditionalInfoComponent,
          };
          break;
        }
        case ComponentGroup.CoBuyerPersonal: {
          nextComponent = {
            groupName: ComponentGroup.CoBuyerPersonal,
            component: new StepComponent(PersonalInfoComponent,
              ComponentName.CoBuyerPersonalInfoComponent, ComponentGroup.CoBuyerPersonal, true, StepType.CoBuyer),
            componentName: ComponentName.CoBuyerPersonalInfoComponent,
          };
          break;
        }
        case ComponentGroup.CoBuyerResidence: {
          nextComponent = {
            groupName: ComponentGroup.CoBuyerResidence,
            component: new StepComponent(ResidenceInfoComponent,
              ComponentName.CoBuyerResidenceInfoComponent, ComponentGroup.CoBuyerResidence, true, StepType.CoBuyer),
            componentName: ComponentName.CoBuyerResidenceInfoComponent,
          };
          break;
        }
        case ComponentGroup.CoBuyerEmployment: {
          nextComponent = {
            groupName: ComponentGroup.CoBuyerEmployment,
            component: new StepComponent(EmploymentInfoComponent,
              ComponentName.CoBuyerEmploymentInfoComponent, ComponentGroup.CoBuyerEmployment, true, StepType.CoBuyer),
            componentName: ComponentName.CoBuyerEmploymentInfoComponent,
          };
          break;
        }
        case ComponentGroup.CoBuyerAdditional: {
          nextComponent = {
            groupName: ComponentGroup.CoBuyerAdditional,
            component: new StepComponent(AdditionalInfoComponent,
              ComponentName.CoBuyerAdditionalInfoComponent, ComponentGroup.CoBuyerAdditional, true, StepType.CoBuyer),
            componentName: ComponentName.CoBuyerAdditionalInfoComponent,
          };
          break;
        }
      }
      this.nextComponentService.loadComponent(nextComponent);
    }
  }


}
